// src/components/listing/PriceBadge.js
// Badge d'affichage du prix - NE PAS MODIFIER

import React from 'react';
import { formatPriceWithUnit } from '../../utils/formatPrice';
import { useLanguage } from '../../hooks/useLanguage';

const PriceBadge = ({ price, priceType = 'perMonth', size = 'medium' }) => {
  const { language } = useLanguage();

  const sizes = {
    small: { fontSize: '13px', padding: '4px 8px' },
    medium: { fontSize: '15px', padding: '6px 12px' },
    large: { fontSize: '18px', padding: '8px 16px' },
  };

  const currentSize = sizes[size] || sizes.medium;

  const styles = {
    badge: {
      display: 'inline-flex',
      alignItems: 'center',
      backgroundColor: 'rgba(255, 215, 0, 0.15)',
      color: '#FFD700',
      borderRadius: '8px',
      fontWeight: '700',
      whiteSpace: 'nowrap',
      ...currentSize,
    },
  };

  return (
    <div style={styles.badge}>
      {formatPriceWithUnit(price, priceType, language)}
    </div>
  );
};

export default PriceBadge;